import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Popper, IconButton, Box, ClickAwayListener } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { useTranslate } from 'react-admin';

const useStyles = makeStyles(theme => ({

    typography: {
        padding: theme.spacing(2)
    },
    arrow: {
        position: "absolute",
        marginTop: '1em',
        fontSize: 15,
        width: "3em",
        height: "1em",

        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: 0,
            height: 0,
            borderStyle: "solid"
        }
    },
    popper: {
        zIndex: 100000,
        marginLeft: "2em",
        marginTop: '2em',
        width: 200,
        borderRadius: "20px",
        WebkitBoxShadow: ' -5px 6px 5px 0px rgba(0,0,0,0.2)',
        MozBoxShadow: '-5px 6px 5px 0px rgba(0,0,0,0.2)',
        boxShadow: '-5px 6px 5px 0px rgba(0,0,0,0.2)',
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: "-0.9em",
            height: "3em",
            width: "1em",
            "&::before": {
                borderWidth: "1em 1em 1em 0",
                borderColor: `transparent ${
                    theme.palette.background.paper
                    } transparent transparent`
            }
        },

    },
    icon: {
        backgroundColor: 'white',
        padding: '2px 7px'
    }
}));

export default function PositionedPopper({ title, content, icon }) {
    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const translate = useTranslate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [arrowRef, setArrowRef] = React.useState(null);
    const classes = useStyles();

    return (

        <ClickAwayListener onClickAway={handleClose}>
            <div>
                <Popper
                    className={classes.popper}
                    open={open}
                    anchorEl={anchorEl}
                    placement="right"
                    transition
                    modifiers={{

                        arrow: {
                            enabled: true,
                            element: arrowRef
                        }
                    }}
                >
                    <span className={classes.arrow} ref={setArrowRef} />
                    <Paper>
                        <Box pl={2} pr={1} py={1}>
                            <Box>
                                <Typography variant='h6'>{title}</Typography>
                            </Box>
                            <Box my={1}>
                                <Typography variant='subtitle2' color='textSecondary'>
                                    {content}
                                </Typography>
                            </Box>
                            <Box display='flex' justifyContent='flex-end'>
                                <Button color='primary' onClick={handleClose} size='small'>{translate(`pos.common.close`)}</Button>
                            </Box>
                        </Box>

                    </Paper>
                </Popper>
                <IconButton onClick={handleClick} color='primary' size='small' className={classes.icon}>
                    {icon}
                </IconButton>
            </div>
        </ClickAwayListener>

    );
}
